const services = [
  {
    title: "Mobile App Development",
    tags: [
      "Javascript",
      "React Native CLI",
      "Expo CLI",
      "JSX",
      "Java",
      "XML",
      "Android Platform",
      "Firebase",
      "Moralis",
      "Web3",
      "Wallet Connect",
      "MetaMask",
      "Trust Wallet",
      "REST APIs",
      "Redux",
      "Mobx",
      "ES6"
    ],
    icon: "https://i.imgur.com/ZnTvvLQ.png",
  },
  {
    title: "Mobile Frontend Development",
    tags: [
      "Animations",
      "StyleSheet",
      "AntDesign",
      "Entypo",
      "EvilIcons",
      "Feather",
      "FontAwesome",
      "FontAwesome5",
      "FontAwesome5Brands",
      "Fontisto",
      "Foundation",
      "Ionicons",
      "MaterialCommunityIcons",
      "MaterialIcons",
      "Octicons",
      "SimpleLineIcons",
      "Zocial",
      "Figma",
      "XD"
    ],
    icon: "https://i.imgur.com/ZnTvvLQ.png",
  },
  // {
  //   title: "Graphic Designing",
  //   tags: [
  //     "Logo",
  //     "Flyer",
  //     "Business Card",
  //     "Pamphlet",
  //     "Poster",
  //     "Penaflex",
  //     "Social Media Post",
  //   ],
  //   icon: "https://i.imgur.com/MKS4LWy.png",
  // },

]

export default services
